import { Grid } from "@mui/material"
import { Identifier,  useListContext, useNotify, useUpdate } from "react-admin";
import { Photo } from "../types";
import { PhotoCard } from "./PhotoCard"

type Props = {
    onItemSelect?: (data: Photo) => void
}

export const PhotoGrid = ({ onItemSelect, ...props }: Props) => {
    const { data: photos } = useListContext<Photo>();

    const notify = useNotify();

    const [update] = useUpdate();
    const updatePhoto = (pid: Identifier, data: Partial<Photo>) => {
        update("photo", { id: pid, data }, {
            // TODO: not workin, investigate
            mutationMode: 'optimistic',//'undoable',

            onSuccess: () => {
                notify('Moderated', { type: 'info', undoable: true });
            }
        })
    }


    return (
        <Grid container spacing={2}>
            {
                photos?.map((photo) => {
                    // const photo = photos[id];
                    return (
                        <Grid key={photo.id} size={{ xs: 12, sm: 6, md: 4, lg: 3, xl: 2 }} >
                            <PhotoCard photo={photo}
                                onItemSelect={() => { onItemSelect?.(photo) }}
                                onUpdate={(pdata) => updatePhoto(photo.id, pdata)}
                            />
                        </Grid>
                    )
                })
            }
        </Grid >
    )

}